import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { DriverPeriodFilter } from "components/DriverPeriodFilter";
import { DriverCard, DriverListSkeleton, EmptyState } from "components/DriverCard";
import { PageTitle } from "components/PageTitle";
import { driverDashboardService } from "services/driverDashboardService";
import { IDriverBoxes } from "interfaces/IDriverDashboard";
import { BoxesRow, BoxesValue, BoxesLabel, Balance, LimitationNote } from "./styles";

const TODAY = dayjs().format("YYYY-MM-DD");

export function DriverBoxes() {
  const [startDate, setStartDate] = useState(dayjs().subtract(7, "day").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(TODAY);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<IDriverBoxes | null>(null);

  useEffect(() => {
    setLoading(true);
    driverDashboardService
      .getMyBoxes({ startDate, endDate })
      .then(setData)
      .finally(() => setLoading(false));
  }, [startDate, endDate]);

  return (
    <div aria-busy={loading}>
      <PageTitle>Caixas</PageTitle>

      <DriverPeriodFilter
        startDate={startDate}
        endDate={endDate}
        onChange={(start, end) => {
          setStartDate(start);
          setEndDate(end);
        }}
        disabled={loading}
      />

      {loading ? (
        <DriverListSkeleton cards={3} rows={2} />
      ) : (
        <>
          {(data?.results?.length ?? 0) === 0 && (
            <EmptyState>Nenhum registro de caixas no período selecionado.</EmptyState>
          )}
          {data?.results?.map((day) => {
            const balance = day.boxesSent - day.boxesReturned;
            return (
              <DriverCard key={day.date} title={`${dayjs(day.date).format("DD/MM/YYYY")} - Rota ${day.route}`}>
                <BoxesRow>
                  <div>
                    <BoxesValue>{day.boxesSent}</BoxesValue>
                    <BoxesLabel>Enviadas</BoxesLabel>
                  </div>
                  <div>
                    <BoxesValue>{day.boxesReturned}</BoxesValue>
                    <BoxesLabel>Retornadas</BoxesLabel>
                  </div>
                  <div>
                    <Balance pending={balance > 0}>{balance}</Balance>
                    <BoxesLabel>Saldo</BoxesLabel>
                  </div>
                </BoxesRow>
              </DriverCard>
            );
          })}
          {data?.limitation && <LimitationNote>{data.limitation}</LimitationNote>}
        </>
      )}
    </div>
  );
}

export default DriverBoxes;